<div
    *transloco="let t"
    class="bazis-control"
    [class]="'bazis-control ' + cssClassSizeControl"
>
    <bazis-label
        [title]="t(titleKey, titleParams)"
        [required]="required"
    >
    </bazis-label>

    <div
        class="bazis-control__field-group"
        [class.bazis-control__field-group--disabled]="disabled"
        [class.bazis-control__field-group_estimated]="isEstimated"
    >
        <bazis-control-field-start [icon]="leftIcon"> </bazis-control-field-start>

        <div class="bazis-control__field-wrapper">
            <div class="bazis-control__field">
                <span>{{ value }}</span>
            </div>
        </div>

        <bazis-control-field-end
            [icon]="rightIcon"
            [unitText]="t(unitKey)"
        >
        </bazis-control-field-end>
    </div>
    <div
        *ngIf="noteKey"
        class="bazis-control__note"
    >
        {{ t(noteKey, noteParams) }}
    </div>
</div>
